import { Box } from "@mui/material";
import { useTranslation } from "hhn-commons";
import {
  ReferralHeading,
  ReferralInfoContainer,
  ReferralInfoText,
  ReferralSubHeading,
} from "./ReferralAttachment.style";
import { IGroupInfo } from "@home-health-notify/domain";

export const ReferralInfo = ({ groupInfo }: { groupInfo: IGroupInfo }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });
  return (
    <ReferralInfoContainer>
      <ReferralInfoText>{tNs("referralInfo")}</ReferralInfoText>
      <Box>
        <ReferralHeading>{tNs("referralSource")}</ReferralHeading>
        <ReferralSubHeading>
          {groupInfo.referralSource ? groupInfo.referralSource : tNs("tbd")}
        </ReferralSubHeading>
        <ReferralHeading>{tNs("communityLiaison")}</ReferralHeading>
        <ReferralSubHeading>
          {groupInfo.communityLiaisoning
            ? groupInfo.communityLiaisoning
            : tNs("tbd")}
        </ReferralSubHeading>
      </Box>
    </ReferralInfoContainer>
  );
};
